export default [
  {
    value: '√',
    icon: 'diag-supported',
    en: 'This feature is supported',
    cn: '表示此功能支持'
  },
  {
    value: '※',
    icon: 'diag-partially-supported',
    en: 'This feature is partially supported',
    cn: '表示此功能部分支持'
  },
  //   {
  //     value: '×',
  //     icon: 'diag-notsupported',
  //     en: 'This feature is not supported',
  //     cn: '表示此功能不支持'
  //   },
  {
    value: '×',
    icon: 'diag-notavailable',
    en: 'Blank: This feature is not equipped or not supported',
    cn: '空白: 表示未配备或不支持'
  }
]
